import script from "./ShareholderUniqueness.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareholderUniqueness.vue?vue&type=script&setup=true&lang=js"

import "./ShareholderUniqueness.vue?vue&type=style&index=0&id=d97207ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d97207ca"]])

export default __exports__